import { useEffect, type ReactNode } from "react";

export interface LegalSection {
  heading: string;
  body: ReactNode;
}

export const OPERATOR = "Yellow Albatross Systems Inc.";
export const CONTACT_EMAIL = "info@yellowalbatross.ca";
export const EFFECTIVE = "November 3, 2026";

export function Mail() {
  return <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>;
}

/** Shared layout for the privacy policy and terms of service. */
export default function LegalPage({ eyebrow, title, intro, sections }: {
  eyebrow: string;
  title: string;
  intro: ReactNode;
  sections: LegalSection[];
}) {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · Set & Ledger`;
    return () => {
      document.title = previous;
    };
  }, [title]);

  return (
    <article className="legal-page">
      <div className="section-eyebrow">{eyebrow}</div>
      <h1 className="section-heading">{title}</h1>
      <p className="legal-updated">Effective {EFFECTIVE}</p>
      <div className="legal-intro">{intro}</div>
      <nav className="legal-toc" aria-label="Contents">
        <ol>
          {sections.map((s, i) => (
            <li key={s.heading}>
              <a href={`#s${i + 1}`}>{s.heading}</a>
            </li>
          ))}
        </ol>
      </nav>
      {sections.map((s, i) => (
        <section key={s.heading} id={`s${i + 1}`} className="legal-section">
          <h2>
            {i + 1}. {s.heading}
          </h2>
          {s.body}
        </section>
      ))}
    </article>
  );
}
